import { msg } from "../locales/translate";
import { DataProvider } from "badmfck-signal";
import { IExecutorResponse } from "badmfck-signal/dist/DataProvider";
import { GD } from "src/GD";
import { ITerminal } from "src/types/types";

export class TerminalService {
	terminals: DataProvider<{ projectID: number }, ITerminal[]> = new DataProvider({ cacheTime: 0 }, "Terminals");

	//!TODO: need project_id?;
	constructor() {
		this.terminals.setExecutor(
			async _ =>
				(await GD.REQ_API.request({
					method: "terminal/list",
					data: {
					},
				})) as IExecutorResponse<ITerminal[]>
		);

		GD.B_TERMINALS.onRequest(async _ => {
			if (_?.force) {
				this.terminals.reset();
			}
			GD.B_TERMINALS.invoke(await this.terminals.load());
		});

		GD.REQ_TERMINAL.listener = async req => this.getTerminal(req);

		GD.REQ_TERMINAL_SAVE.listener = async req => this.saveTerminal(req);

		GD.S_PROJECT_SELECTED.subscribe(() => {
			this.terminals.reset();
		});
	}

	generateNewTerminal(): ITerminal {
		const res: ITerminal = {
			created_at: 0,
			id: -1,
			name: "",
			type: "apple_pay",
			updated_at: 0,
			icon: "",
			status: "active",
		};
		return res;
	}

	
	async getTerminal(req: { terminalID: number }): Promise<IAPIResponse<ITerminal> | null> {
		//if (!req) return { error: { code: -1, message: "Invalid getAcquirer request" } };
		if (!req) return null;
		const terminalID = req.terminalID;

		if (!terminalID) return { error: { code: -1, message: msg("invalidTerminalId") } };

		if (terminalID === -1) {
			return {
				data: this.generateNewTerminal(),
			};
		}

		const terminal = await GD.REQ_API.request({
			method: "terminal/get",
			data: {
				id: terminalID,
			},
		});

		return terminal;
	}

	async saveTerminal(req: ITerminal): Promise<IAPIResponse<ITerminal>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };

		(req as any).project_id = (await GD.REQ_CURRENT_PROJECT.request())?.id;

		if (!req.id || req.id === -1) {
			// NEW ADD
			res = await GD.REQ_API.request({
				method: "terminal/add",
				data: req,
			});
		} else {
			// EXISTING EDIT
			res = await GD.REQ_API.request({
				method: "terminal/update",
				data: req,
			});
		}

		if (res && !res.error) {
			GD.S_TERMINALS_UPDATE.invoke();
			this.terminals.reset();
			GD.B_TERMINALS.invoke(await this.terminals.load());
			//  GD.REQ_ACQUIRER.request({acquirerID:req.id})
		}
		return res;
	}
}
